<template lang="pug">
y-dialog(v-if="showDialog" v-model="showDialog" :max-width="600" :fullscreen="$vuetify.breakpoint.mobile" persistent fluid scrollable content-class="round-2xl")
  v-card
    v-card-title.pt-4.pb-2.px-4
      div(style="word-break: break-word;")
        div.text-xl.font-semibold.neutral700--text Finish counting?
        div.text-xs.neutral700--text.mt-2 This action will be done immediately and can’t be undone. Click “Confirm” to proceed
    v-card-text.px-4.pb-6
      v-card.round-lg.mt-4(outlined)
        div.px-3
          div.text-md.font-semibold.neutral700--text.mt-2 {{ stocktake.name }}
          div.mt-2
            div
              div.d-flex.align-center
                v-icon(color="neutral700" size="18") $yzi-users-solid-03
                div.text-xs.neutral700--text.ml-3 {{ stocktake.member.name }}
            div
              div.d-flex.align-center
                v-icon.mb-1(color="neutral700" size="18") $yzi-calendar-solid
                div.text-xs.neutral700--text.font-semibold.ml-3 Start date:
                div.text-xs.neutral700--text.ml-1 {{ stocktake.created | humanizeDate }}
            div
              div.d-flex.align-center
                v-icon.mb-1(color="neutral700" size="18") $yzi-clock-check-solid
                div.text-xs.neutral700--text.font-semibold.ml-3 Start time:
                div.text-xs.neutral700--text.ml-1 {{ stocktake.created | displayTime2 }}

          div.text-sm.font-semibold.mt-2 {{ changedProducts.length }} items counted

        div.d-flex.justify-center.my-16(v-if="isFetchingProducts")
          v-progress-circular(:width="2" :size="30" color="primary" indeterminate)
        
        template(v-else)
          template(v-for="product in products")
            div.pa-3(:key="product.id")
              v-row(no-gutters)
                v-col.pr-1(cols="6" style="word-break: break-word;")
                  .text-xs.font-medium.neutral700--text {{ product.name }}
                v-col.pl-1(cols="6" align="right" style="word-break: break-word;")
                  .text-xs.neutral700--text(v-if="getStockUnit(product)") {{ getStockUnit(product) }}
                  .text-xs.font-medium.success500--text(v-if="product.inventory_qty") Current count: {{ product.inventory_qty }}
                  .text-xs.font-medium.info500--text(v-if="checkActualCount(product)") Actual count: {{ checkActualCount(product) }}
            v-divider

    v-divider
    v-card-actions.py-2.px-4
      y-button.mr-4(:label="$t('cancel')" underline color="neutral700" size="sm" button-class="px-0" @click="closeDialog")
      v-spacer
      y-button(label="Confirm" text-color="neutral100" color="neutral700" size="sm" dark :loading="isLoading" @click="saveData")

</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  components: {  },
  props: {
    open: {
      type: Boolean,
      default: false
    },
    stocktake: {
      type: Object,
      default: (() => {})
    },
    changedProducts: {
      type: Array,
      default: (() => [])
    },
  },
  data () {
    return {
      isLoading: false,
      isFetchingProducts: false,
      products: []
    }
  },
  computed: {
    ...mapGetters({ company: 'getCompany' }),
    showDialog: {
      get () {
        return this.open 
      },
      set (newValue) {
        this.$emit('update:open', newValue)
      }
    },
  },
  mounted () {
    this.fetchProducts()
  },
  methods: {
    getStockUnit (item) {
      if (item.uom_conversion_enabled && item.uom_conversions && item.uom_conversions.length) {
        return item.uom_conversions[item.uom_conversions.length - 1].convert_to || ''
      }
      return item.uom || ''
    },
    ...mapActions(['showMessage']),
    fetchProducts () {
      this.isFetchingProducts = true
      let params = {
        status: 'published',
        page_size: -1,
        fields: 'id,name,uom,inventory_qty,location',
        ids: this.changedProducts.map(m => m.id).join()
      }
      this.$axios.get(`/clinics/${this.company.slug}/inventories`, { params })
        .then(resp => {
          this.products = resp.data.results
          this.next = resp.data.next
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
        .finally(() => {
          this.isFetchingProducts = false
        })
    },
    checkActualCount (product) {
      let count = null
      let diff = this.checkStockDiff(product)
      if (diff !== null) {
        count = product.inventory_qty + diff
      }
      return count
    },
    checkStockDiff (product) {
      let quantity = null
      let findProduct = this.changedProducts.find(f => f.id === product.id)
      if (findProduct){
        quantity = findProduct.change
      }
      return quantity
    },
    saveData () {
      this.$emit('finish')
      this.closeDialog()
    },
    closeDialog () {
      this.showDialog = false
    },
  }
}
</script>

<style lang="scss" scoped>
::v-deep {
  .v-text-field--outlined {
    fieldset {
      border-color: var(--v-neutral400);
    }
  } 
  .error--text {
    color: var(--v-danger500) !important;
    fieldset {
      border-color: var(--v-danger500);
    }
  }
}
</style>